import { SvgIcon } from "@mui/material";

export const TeamDetailsSnapShotIcon = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 94 94">
      <g>
        <path
          d="M47,0C21.1,0,0,21.1,0,47s21.1,47,47,47s47-21.1,47-47S72.9,0,47,0z M47,89C23.8,89,5,70.2,5,47 C5,23.8,23.8,5,47,5c23.2,0,42,18.8,42,42C89,70.2,70.2,89,47,89z"
          fill="currentColor"
        />
        <rect x="58" y="25.7" width="11.8" height="42.2" fill="currentColor" />
        <rect x="41.1" y="36.9" width="11.8" height="31" fill="currentColor" />
        <rect x="24.2" y="48" width="11.8" height="19.8" fill="currentColor" />
      </g>
    </SvgIcon>
  );
};
